import { render, staticRenderFns } from "./ManageSystem.vue?vue&type=template&id=556e4faf&scoped=true"
import script from "./ManageSystem.vue?vue&type=script&lang=js"
export * from "./ManageSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556e4faf",
  null
  
)

export default component.exports